var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.9999,
    height: 39.9998,
    rx: 19.9999,
    fill: "#FC7360",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5837 21.9848L13.2071 17.2799C12.9748 17.0765 12.7886 16.8259 12.661 16.5447C12.5334 16.2635 12.4674 15.9583 12.4674 15.6495C12.4674 15.3407 12.5334 15.0355 12.661 14.7543C12.7886 14.4731 12.9748 14.2224 13.2071 14.0191L18.5837 9.31415C18.9787 8.96856 19.4857 8.77808 20.0105 8.77808C20.5353 8.77808 21.0423 8.96856 21.4372 9.31415L26.8138 14.0191C27.0462 14.2224 27.2324 14.4731 27.36 14.7543C27.4875 15.0355 27.5535 15.3407 27.5535 15.6495C27.5535 15.9583 27.4875 16.2635 27.36 16.5447C27.2324 16.8259 27.0462 17.0765 26.8138 17.2799L21.4372 21.9848C21.0423 22.3304 20.5353 22.5209 20.0105 22.5209C19.4857 22.5209 18.9787 22.3304 18.5837 21.9848Z",
    stroke: "#FC7360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.427 21.0662L18.5999 26.3572C18.9926 26.694 19.4929 26.8792 20.0104 26.8792C20.5278 26.8792 21.0281 26.694 21.4209 26.3572L27.5937 21.0662",
    stroke: "#FC7360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4271 25.3994L18.6 30.6904C18.9927 31.0273 19.4931 31.2124 20.0105 31.2124C20.5279 31.2124 21.0282 31.0273 21.421 30.6904L27.5938 25.3994",
    stroke: "#FC7360",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.8dbae2bd133948b57bb732a09da78b28.svg";
export { ForwardRef as ReactComponent };